import { render, staticRenderFns } from "./default-psp-setting.vue?vue&type=template&id=5aff053e"
import script from "./default-psp-setting.vue?vue&type=script&lang=js"
export * from "./default-psp-setting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports